import ApiResponse from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/ApiResponse";
import ApiResponseV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/ApiResponseV2";
import PagedResult from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/PagedResult";
import GenericCrudServiceV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/GenericCrudServiceV2";
import HttpClient from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/HttpClient";
import HttpClientV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/HttpClientV2";
import Site from "../models/Site";

export class SiteService extends GenericCrudServiceV2<Site> {
  constructor(protected basePath: string) {
    super(basePath);
  }

  getFormData(site: Site): FormData {
    const formData = new FormData();

    formData.append("dto", JSON.stringify(site));

    return formData;
  }

  getSiteFilter(page: number, pageSize: number, projectExternalId: string, role: string, title: string, isArchived: boolean): Promise<ApiResponse<Site>> {
    let query = `${this.basePath}/setup-all?page=${page}&pageSize=${pageSize}&projectExternalId=${projectExternalId}&role=${role}&title=${title}&isArchived=${isArchived}`;
    return HttpClient.get(query, true);
  }

  getByProjectAndRole(page: number, pageSize: number): Promise<ApiResponse<PagedResult<Site>>> {
    let query = `${this.basePath}/filter?page=${page}&pageSize=${pageSize}`;
    return HttpClient.get(query, true);
  }

  editSite(site: Site): Promise<ApiResponseV2<Site>> {
    return HttpClientV2.put(`${this.basePath}/update/${site.externalId}`, this.getFormData(site));
  }
}
export default new SiteService("/ensolvers-ops/user-sites");
